import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import GridView from "../../../../shared/components/GridView";
import { User, UserListProps } from "../User.type";
import { useState } from "react";
import { Button } from "@mui/material";

const UserList: React.FC<UserListProps> = ({
  users,
  onUserSelect,
  onRowSelectionModelChange,
  rowSelectionModel,
}) => {
  // Define the grid columns
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Full Name",
      flex: 1,
      width: 150,
      renderCell: (params) => (
        <Button
          variant="text"
          color="primary"
          onClick={() => onUserSelect && onUserSelect(params.row)}
        >
          {params.row.firstName} {params.row.lastName}
        </Button>
      ),
    },
    { field: "patientId", headerName: "Patient Id", flex: 1, width: 100 },
    { field: "dateOfBirth", headerName: "Date of Birth", flex: 1, width: 150 },
    { field: "gender", headerName: "Gender", flex: 1, width: 500 },
    { field: "mobileNumber", headerName: "Mobile Number", flex: 1, width: 150 },
    { field: "email", headerName: "Email", flex: 1, width: 200 },
    { field: "address", headerName: "Address", flex: 1, width: 250 },
    { field: "bloodGroup", headerName: "Blood Group", flex: 1, width: 50 },
  ];

  return (
    <>
      <div style={{ height: "400px", width: "100%" }}>
        <GridView
          data={users}
          columns={columns}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={onRowSelectionModelChange}
          onLinkClick={onUserSelect}
          linkColumnNames={[]}
          disableMultipleRowSelection={true}
        ></GridView>
      </div>
    </>
  );
};

export default UserList;
